import React from "react";
import * as Yup from "yup";
import useResponse from "../../hooks/useResponse";
import trimObjectValues from "../../utils/trimObject";
import { useNavigate } from "react-router-dom";
import * as authService from "../../services/userAuthService";
import * as toast from "../../Toast";
import { Box } from "@mui/material";
import { CardContainer, Card } from "../../components/UI";
import { HeaderTitleSubtitle, SuccessAndErrorMessage } from "../../components";

import { Form, FormInput, SubmitLoadingButton } from "../../components/Forms";

import styles from "../login/login.module.css";

const validationSchema = Yup.object().shape({
  email: Yup.string().required().min(6).email().label("Email").trim(),
});

const EmailVerify = () => {
  const [state, dispatch] = useResponse();
  const navigate = useNavigate();

  const handleSubmit = async (loginData) => {
    dispatch.sendingRequst();
    loginData = trimObjectValues(loginData);
    try {
      const emailOrPhoneObj = {};

      emailOrPhoneObj.email = loginData.email;

      const response = await authService.sendOTpToClient(emailOrPhoneObj);
      const { data } = await response.data;

      toast.info(response.data.message);
      dispatch.successResponse(response.data.message);
      navigate(`/verify-otp/${data.token}`);
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 409
      ) {
        dispatch.gotError(ex.response.data.message);
        toast.error(ex.response.data.message);
      }
    }
  };

  return (
    <CardContainer>
      <Card>
        <div className={styles.headingContainer}>
          <HeaderTitleSubtitle
            title="Delete User Account"
            subtitle="Enter your email below to proceed to delete account."
          />
        </div>
        <Form
          initialValues={{
            email: "",
          }}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.5,
            }}
          >
            <FormInput label="Email" name="email" type="email" />
            <SubmitLoadingButton
              buttonText="Send OTP"
              type="submit"
              submitButton={true}
              loading={state.loading}
            />
            <SuccessAndErrorMessage
              error={state.error}
              success={state.message}
            />
          </Box>
        </Form>
      </Card>
    </CardContainer>
  );
};

export default EmailVerify;
